import { useChapterUrlHash, ViewOnDemandWebinarOrganism } from '@online-webinar/player';
import { useParams } from '@online-webinar/router';
import { useAppSelector } from '@online-webinar/store';
import { useEffect } from 'react';

export const ViewOnDemandWebinarPage = () => {
    const { webinarId, linkCode } = useParams({ strict: false });
    const activeChapter = useAppSelector((state) => state.onDemandWebinar.activeChapter);

    useEffect(() => {
        document.body.classList.add('no-menu');
        return () => {
            document.body.classList.remove('no-menu');
        };
    }, []);

    // Keep the URL hash in sync with the active chapter so the URL is shareable.
    // This is intentionally only done in the page (not the organism) so the
    // embedded player does not modify the host page's URL.
    useChapterUrlHash(webinarId!, activeChapter?.chapterTitle);

    return <ViewOnDemandWebinarOrganism webinarId={webinarId!} linkCode={linkCode} />;
};
